module.exports = __webpack_public_path__ + "img/stopwatch.fce8c148.svg";